import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private redirecting = false;

  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isAccountRequest = req.url.includes('/account');

    const request = req.clone({
      withCredentials: true,
    });

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!isAccountRequest && (error.status === 401 || error.status === 403)) {
          if (!this.redirecting) {
            this.redirecting = true;

            this.router
              .navigate(['/login'], {
                queryParams: {
                  ref: 'timeout',
                },
              })
              .finally(() => {
                this.redirecting = false;
              });
          }
        }

        return throwError(() => error);
      })
    );
  }
}

// import { Injectable } from '@angular/core';
// import {
//   HttpEvent,
//   HttpHandler,
//   HttpInterceptor,
//   HttpRequest,
//   HttpResponse,
// } from '@angular/common/http';
// import { Observable, of } from 'rxjs';
// import { Router } from '@angular/router';

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   constructor(private router: Router) {}

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     if (req.url.includes('/account')) {
//       return next.handle(req);
//     }

//     const rm4 = document.cookie.split(';').find((cookie) => cookie.includes('rm4'));

//     if (!rm4) {
//       this.router.navigate(['/login'], {
//         queryParams: {
//           ref: 'timeout',
//         },
//       });
//       return of(new HttpResponse({ status: 302, statusText: 'Redirect' }));
//     }

//     return next.handle(req);
//   }
// }
